import { useTranslation } from "react-i18next";

const timelineKeys = ["2020q1", "2020q3", "2021q2", "2022q1", "2022q4", "2023q2", "2024q1", "2024q4"];

export default function AboutTimeline() {
  const { t } = useTranslation();
  return (
    <section className="py-20 border-t" style={{ borderColor: "var(--border-color)" }}>
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <span
            className="inline-block text-xs font-semibold uppercase tracking-widest mb-4 px-3 py-1 rounded-full"
            style={{ backgroundColor: "rgba(34,197,94,0.1)", color: "var(--accent)" }}
          >
            {t("about.timeline.label")}
          </span>
          <h2 className="text-3xl font-bold" style={{ color: "var(--text-primary)" }}>
            {t("about.timeline.title")}
          </h2>
        </div>

        <div className="relative">
          {/* vertical line */}
          <div
            className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px -translate-x-1/2"
            style={{ backgroundColor: "var(--border-color)" }}
          ></div>

          <div className="space-y-8">
            {timelineKeys.map((key, idx) => {
              const isLeft = idx % 2 === 0;
              return (
                <div
                  key={key}
                  className={`relative flex items-start gap-4 md:gap-0 ${isLeft ? "md:flex-row" : "md:flex-row-reverse"}`}
                >
                  {/* Dot */}
                  <div
                    className="absolute left-6 md:left-1/2 -translate-x-1/2 w-3 h-3 rounded-full mt-1.5 z-10 shrink-0"
                    style={{ backgroundColor: "var(--accent)", border: "2px solid var(--bg-base)" }}
                  ></div>

                  {/* Card — offset from center */}
                  <div className={`ml-14 md:ml-0 ${isLeft ? "md:pr-10 md:w-1/2 md:text-right" : "md:pl-10 md:w-1/2 md:ml-[50%]"}`}>
                    <div
                      className="rounded-xl p-4 inline-block text-left"
                      style={{
                        backgroundColor: "var(--bg-surface)",
                        border: "1px solid var(--border-color)",
                        maxWidth: "320px",
                      }}
                    >
                      <span
                        className="text-xs font-bold mb-1 block"
                        style={{ color: "var(--accent)" }}
                      >
                        {t(`about.timeline.${key}.date`)}
                      </span>
                      <h4 className="text-sm font-semibold mb-1" style={{ color: "var(--text-primary)" }}>
                        {t(`about.timeline.${key}.title`)}
                      </h4>
                      <p className="text-xs leading-relaxed" style={{ color: "var(--text-muted)" }}>
                        {t(`about.timeline.${key}.desc`)}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}